(() => {
  function arrangeCartButtons() {
    const cart = document.querySelector('#mini-cart');
    if (!cart) return;

    const slot = cart.querySelector('.route-no-coverage-slot');
    const routeWidget = cart.querySelector(
      '[data-route-widget-cwc="true"]'
    );

    if (!slot || !routeWidget) return;

    if (routeWidget.parentElement !== slot) {
      slot.appendChild(routeWidget);
    }
  }

  let scheduled = false;

  const observer = new MutationObserver(() => {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      arrangeCartButtons();
    });
  });

  function initialize() {
    arrangeCartButtons();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();